// Split-flap renderer for prices, codes, and short numeric strings.

export function setFlaps(el, str, anim) {
  const chars = str.split('');
  const prev = el.dataset.val || '';
  el.dataset.val = str;
  el.innerHTML = chars
    .map((ch, i) => {
      const colon = ch === ':';
      const flip = anim && ch !== prev[i] ? ' flip' : '';
      return `<span class="flap${colon ? ' colon' : ''}${flip}">${ch}</span>`;
    })
    .join('');
}
